import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const isCdn = !process.env.BASE_URL.includes("/npe") && window.location.href.includes(process.env.BASE_URL);
const routePrefix = isCdn ? "" : "/npe";

const routes = [
  {
    path: routePrefix + "/",
    name: "GuestPayment",
    meta: {
      title: "WisePay",
    },
    component: () => import(/* webpackChunkName: "invoice-payment" */ "@/pages/guest-payment-flow.vue"),
  },
  {
    path: routePrefix + "/payment-success",
    name: "paymentSuccess",
    meta: {
      title: "WisePay | Payment Successful",
    },
    component: () => import(/* webpackChunkName: "result-success" */ "@/pages/result-success.vue"),
  },
  {
    path: routePrefix + "/payment-fail",
    name: "paymentFail",
    meta: {
      title: "WisePay | Payment Unsuccessful",
    },
    component: () => import(/* webpackChunkName: "result-fail" */ "@/pages/result-fail.vue"),
  },
  {
    path: routePrefix + "/search",
    name: "TransactionSearch",
    meta: {
      title: "WisePay | Virtual Terminal",
    },
    component: () => import(/* webpackChunkName: "virtual-terminal" */ "@/pages/virtual-terminal.vue"),
  },
  {
    path: routePrefix + "/sign-up",
    name: "SignUp",
    meta: {
      title: "WisePay | Sign Up",
    },
    component: () => import(/* webpackChunkName: "sign-up" */ "@/pages/npe-signup.vue"),
  },
  {
    path: routePrefix + "/pos",
    name: "Pos",
    meta: {
      title: "WisePay | POS",
    },
    component: () => import(/* webpackChunkName: "sign-up" */ "@/pages/pos-terminal.vue"),
  },
];
const router = new VueRouter({
  mode: "history",
  routes,
});

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.title);

  // If a route with a title was found, set the document (page) title to that value.
  if (nearestWithTitle) document.title = nearestWithTitle.meta.title;

  next();
});

export default router;
